/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TTLORouteLocationRequest
 */
export interface TTLORouteLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof TTLORouteLocationRequest
     */
    airportCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TTLORouteLocationRequest
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TTLORouteLocationRequest
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TTLORouteLocationRequest
     */
    regionCode?: string | null;
}

export function TTLORouteLocationRequestFromJSON(json: any): TTLORouteLocationRequest {
    return TTLORouteLocationRequestFromJSONTyped(json, false);
}

export function TTLORouteLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLORouteLocationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'airportCode': !exists(json, 'airportCode') ? undefined : json['airportCode'],
        'cityCode': !exists(json, 'cityCode') ? undefined : json['cityCode'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
    };
}

export function TTLORouteLocationRequestToJSON(value?: TTLORouteLocationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'airportCode': value.airportCode,
        'cityCode': value.cityCode,
        'countryCode': value.countryCode,
        'regionCode': value.regionCode,
    };
}


